/**
 * cart-variant-change.js
 * Permet de changer la variante d'un article directement dans le panier.
 * On retire la ligne courante et on ajoute la nouvelle variante.
 */

(function () {
  'use strict';

  const SECTIONS = 'cart-drawer,cart-icon-bubble';

  async function changeCartVariant(lineIndex, newVariantId, quantity) {
    // 1. Retirer l'ancienne ligne
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 }),
    });

    // 2. Ajouter la nouvelle variante
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(newVariantId, 10), quantity: quantity }),
    });

    // 3. Récupérer les sections mises à jour
    const resp = await fetch('/?sections=' + SECTIONS);
    if (!resp.ok) throw new Error('Section fetch failed');
    return resp.json();
  }

  function applyCartSections(data) {
    const parser = new DOMParser();

    // Mettre à jour le contenu du drawer
    if (data['cart-drawer']) {
      const newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');

      // Articles
      const newItems = newDoc.getElementById('CartDrawer-CartItems');
      const curItems = document.getElementById('CartDrawer-CartItems');
      if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

      // Barre livraison gratuite
      const newShipping = newDoc.querySelector('.cart-free-shipping');
      const curShipping = document.querySelector('.cart-free-shipping');
      if (newShipping && curShipping) curShipping.outerHTML = newShipping.outerHTML;

      // En-tête (compteur)
      const newHeading = newDoc.querySelector('.drawer__heading');
      const curHeading = document.querySelector('.drawer__heading');
      if (newHeading && curHeading) curHeading.innerHTML = newHeading.innerHTML;

      // Footer total
      const newFooter = newDoc.querySelector('.cart-drawer__footer');
      const curFooter = document.querySelector('.cart-drawer__footer');
      if (newFooter && curFooter) curFooter.innerHTML = newFooter.innerHTML;
    }

    // Mettre à jour le bubble du header
    if (data['cart-icon-bubble']) {
      const newDoc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
      const newBubble = newDoc.querySelector('.cart-count-bubble');
      const curBubble = document.querySelector('.cart-count-bubble');
      if (newBubble && curBubble) curBubble.outerHTML = newBubble.outerHTML;
    }
  }

  function setSelectLoading(select, loading) {
    select.disabled = loading;
    const wrapper = select.closest('.cart-item__variant-change');
    if (wrapper) wrapper.classList.toggle('cart-item__variant-change--loading', loading);
  }

  // Écoute les changements de variante dans le panier
  document.addEventListener('change', async function (e) {
    const select = e.target.closest('.cart-item__variant-select');
    if (!select) return;

    const lineIndex = parseInt(select.dataset.line, 10);
    const quantity = parseInt(select.dataset.quantity, 10) || 1;
    const newVariantId = select.value;

    setSelectLoading(select, true);

    try {
      const data = await changeCartVariant(lineIndex, newVariantId, quantity);
      applyCartSections(data);
    } catch (err) {
      console.error('[cart-variant-change] Erreur :', err);
      setSelectLoading(select, false);
    }
  });
})();
